export interface RecordEventState {
  isFromInfantForm?: boolean;
}

export const eventNames = {
  close: 'close_folder',
  caregiverIsPregnant: 'caregiver_is_pregnant',
  newChildInFamily: 'new_child_in_family',
  caregiverHasChanged: 'caregiver_has_changed',
};
